import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex'

export default {
  computed: {
    ...mapState({
      UserLogin: 'UserLogin',
      Common: 'Common',
      SpaceManagement: 'SpaceManagement',
      leftMenuIndex:"leftMenuIndex",
      docFontSize:'fontSize',
    })
  },
  methods: {
    ...mapMutations({
      SET_LEFTMENU_INDEX:"SET_LEFTMENU_INDEX",
      setLeftMenuShow_M:'SET_LEFTMENU_SHOW',
      SETOPTIONS: 'UserLogin/SETOPTIONS'
    }),
    ...mapActions({
      sendLoginOut: 'Common/sendLoginOut',
      getOSSsignature: 'Common/getOSSsignature',
      getOssFileState: 'SpaceManagement/getOssFileState'
    })

  }

}



// WEBPACK FOOTER //
// ./src/components/Mixins.js